<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': profiles.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Profile List') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Name') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ProfileListItem v-for="profile in profiles" :profile="profile" :key="profile.id"
            @edit="showProfileModal($event)" @duplicate="showProfileModal($event, 'duplicate')"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" :application="application" />
          <EmptyListItem v-if="!profiles || profiles.length == 0" :loading="loading" :colspan="3" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="3" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
  <ProfileModal ref="ProfileModal" @updated="$emit('updated', $event)" @created="$emit('updated', $event)"
    :application="application" />
</template>

<script>
import ProfileListItem from "@/components/profile/ProfileListItem.vue";
import ProfileModal from "@/components/profile/ProfileModal.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    ProfileListItem,
    ProfileModal,
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    application: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    profiles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    showProfileModal(profile, mode) {
      if (!this.$refs.ProfileModal) return;
      this.$refs.ProfileModal.show(profile.id, mode);
    },
  },
};
</script>